import { loadImageFromSource } from "./validateFace";

/**
 * Creates a preview of the uploaded image without face detection box
 */
const createPreview = async (source) => {
  try {
    // Simply load and return the original image without any face detection drawing
    const img = await loadImageFromSource(source);

    // Create canvas for drawing but don't draw any face detection box
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");

    // Draw the original image only
    ctx.drawImage(img, 0, 0);

    // Return as data URL
    const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
    return dataUrl;
  } catch (err) {
    console.error("❌ שגיאה ביצירת תצוגה מקדימה:", err);
    // In case of error, return the original source if it's a string
    if (typeof source === "string") {
      return source;
    }
    return null;
  }
};

export default createPreview;
